<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="relative md:col-span-1">
            <div class="px-4 sm:px-0 md:sticky top-4">
                <h3 class="text-lg font-medium text-gray-900">
                    <slot name="title"></slot>
                </h3>
                <div class="mt-1 text-sm text-gray-600">
                    <slot name="description"></slot>
                </div>
                <InputError v-if="error" :message="error"/>
            </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow sm:rounded-md" :class="{'border border-red-600': error}">
                <div class="px-4 py-5 bg-white sm:p-6 sm:rounded-t-md" :class="{'sm:rounded-b-md': !$slots.footer}">
                    <slot></slot>
                </div>
                <div v-if="$slots.footer" class="px-4 py-3 bg-gray-50 text-right sm:px-6 sm:rounded-b-md">
                    <div class="flex justify-end items-center rounded-md">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import InputError from "@/Components/Form/InputError";

export default {

    props: {
        error: String
    },

    components: {
        InputError
    },
}
</script>
